import gql from 'graphql-tag'

export default gql`
  mutation HallOfFameItemCreate(
    $image: Upload!
    $slug: String!
    $title: String!
    $type: HallOfFamerType!
    $url: String
    $userIds: [ID!]
  ) {
    hallOfFamerCreate(
      image: $image
      slug: $slug
      title: $title
      type: $type
      url: $url
      userIds: $userIds
    ) {
      id
    }
  }
`
